import ThreeCardOracleSpread from '../../components/oracle/ThreeCardOracleSpread';

const ThreeCardOracleSpreadPage = ({lang = 'es'}) => {

  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      {/* Usa el componente con el nuevo nombre */}
      <ThreeCardOracleSpread lang={lang} />
    </div>
  );
};

export default ThreeCardOracleSpreadPage;